(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.components:mxPreventMenuClose
	 * @module mx.components
	 * @restrict 'AC'
	 * @description
	 *
	 * This directive is used to prevent closing of md-menu.
	 * If any element inside md-menu-content has ng-click handler and doesn't have attribute 'md-prevent-menu-close' then md-menu will be closed after click on such element.
	 * For simple elements (ex. 'button') it is possible just to add attribute 'md-prevent-menu-close' to it.
	 * But for complex components it is impossible to add such attribute for every clickable child, mxPreventMenuClose can be used so for such cases.
	 *
	 * mxPreventMenuClose will add 'md-prevent-menu-close' for all static children.
	 * Also it adds handler for md-menu to detect new dynamic clickable children inside element with 'mx-prevent-menu-close'
	 *
	 * @usage <md-menu-content> <mx-some-element mx-prevent-menu-close></mx-some-element> </md-menu-content>
	 */
	angular.module('mx.components').directive('mxPreventMenuClose', function mxPreventMenuCloseDirective() {
		return {
			restrict: 'A',
			controller: MxPreventMenuCloseController,
		};
	});

	MxPreventMenuCloseController.$inject = ['$scope', '$element', '$mdUtil'];
	function MxPreventMenuCloseController($scope, $element, $mdUtil) {
		var vm = this;
		var containers = [];

		vm.$onInit = function () {
			/* evalAsync is used to wait creating of parent-container */
			$scope.$evalAsync(function () {
				var mdMenuContent = $($mdUtil.getClosest($element, 'MD-MENU-CONTENT'));
				if (!mdMenuContent) {
					return;
				}
				setPreventAttributesForAllClickableChildren($element);

				var mdMenuContentParent = mdMenuContent.parent()[0];

				/* all mx-prevent-menu-close directives should create only one handler for md-menu-content with array of containers */
				if (!mdMenuContentParent._mxMenuPreventCloseHandler) {
					mdMenuContentParent._mxMenuPreventCloseHandler = mxMenuPreventCloseHandler;
					mdMenuContentParent.addEventListener('click', mxMenuPreventCloseHandler, true);
				}

				if (mdMenuContentParent._mxMenuPreventCloseContainers) {
					containers = mdMenuContentParent._mxMenuPreventCloseContainers;
				} else {
					mdMenuContentParent._mxMenuPreventCloseContainers = containers;
				}

				containers.push($element[0]);
			});
		};

		function mxMenuPreventCloseHandler(event) {
			var target = event.target;
			var hasNotPreventedClickHandler = false;

			do {
				if (target.tagName === 'MD-MENU-CONTENT') {
					return;
				}

				if (target.hasAttribute('ng-click') && !target.hasAttribute('md-prevent-menu-close')) {
					hasNotPreventedClickHandler = true;
				}

				if (containers.indexOf(target) >= 0) {
					if (hasNotPreventedClickHandler) {
						setPreventAttributesForAllClickableChildren(target);
					}
					return;
				}
				target = target.parentNode;
			} while (target);
		}

		function setPreventAttributesForAllClickableChildren(target) {
			$(target)
				.find('[ng-click]')
				.each(function () {
					$(this).attr('md-prevent-menu-close', '');
				});
		}
	}
})();
